import ServiceDetailPage from "@/components/ServiceDetailPage";

const Matrix = () => <ServiceDetailPage pageKey="matrix" />;

export default Matrix;
